module.exports = __webpack_public_path__ + "static/media/bannerBlackoutHomeMobile.49c80f83.jpg";